<ccl-base-popup
    [title]="getPopup().title"
    [navLinks]="getPopup().navLinks"
    [saveMessage]="getPopup().saveMessage"
    [showFooter]="getPopup().showFooter"
>
    <div class="c-popup__section"><router-outlet></router-outlet></div>
</ccl-base-popup>
